import React from 'react';
import { db } from '../../../firebase/Firebase';
import { updateDoc, doc } from 'firebase/firestore';
import jsPDF from 'jspdf';

const DeliveryCard = ({ data, onClick }) => {
  const isArchived = data.deliveryStage === 'Archive';
  const cardStyle = {
    border: '1px solid #ddd',
    padding: '15px',
    margin: '15px',
    borderRadius: '8px',
    boxShadow: isArchived ? 'none' : '0 4px 8px rgba(0, 0, 0, 0.1)',
    cursor: 'pointer',
    position: 'relative',
    backgroundColor: isArchived ? '#e0e0e0' : '#ffffff',
    opacity: isArchived ? 0.5 : 1
  };

  const buttonStyle = {
    zIndex: 1,
    padding: '10px 15px',
    border: 'none',
    background: '#FFC300',
    color: '#fff',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'background 0.3s',
    marginLeft: 10,
    height: 40,
    width: 250,
    borderRadius: 8,
  };

  const buttonContainerStyle = {
    position: 'absolute',
    top: '10px',
    justifyContent: 'space-between',
    right: '10px',
    display: 'flex',
    flexDirection: 'row',
    height: '150px',
    width: '300px',
  };

  const infoStyle = {
    marginBottom: '10px',
    fontSize: '14px'
  };

  const imgRowStyle = {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    overflowX: 'auto',
    padding: '5px 0'
  };

  const imgStyle = {
    width: '100px',
    height: '100px',
    objectFit: 'cover',
    borderRadius: '5px',
    cursor: 'pointer'
  };

  const handleImageClick = (url) => {
    window.open(url, '_blank');
  };

  const handleApproveClick = async (e) => {
    e.stopPropagation();

    let updatedStage;
    switch (data.deliveryStage) {
      case 'Purchaser':
        updatedStage = 'Accounting';
        break;
      case 'Accounting':
        updatedStage = 'Archive';
        break;
      default:
        return;
    }

    const deliveryRef = doc(db, 'Deliveries', data.id);
    try {
      await updateDoc(deliveryRef, { deliveryStage: updatedStage });
      console.log('Status updated successfully in Firebase');
    } catch (error) {
      console.error('Error updating status in Firebase:', error);
    }
  };

  const handleDownloadPDF = async (e) => {
    e.stopPropagation();

    const pdf = new jsPDF('landscape', 'mm', 'a4');
    pdf.setFontSize(18);
    pdf.text(`Delivery Details`, 10, 10);
    pdf.setFontSize(12);
    pdf.text(`Status: ${data?.deliveryStatus}`, 10, 30);
    pdf.text(`Stage: ${data?.deliveryStage}`, 10, 40);
    pdf.text(`Project: ${data?.deliveryProject}`, 10, 50);
    pdf.text(`Vendor: ${data?.deliveryVendor}`, 10, 60);
    pdf.text(`Notes: ${data?.deliveryNotes}`, 10, 70);
    pdf.text(`Receipts:`, 10, 80);
    pdf.text(`Materials:`, 10, 140);

    const loadImage = (url) => {
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = url;
      });
    };

    const convertToBase64 = (img) => {
      const canvas = document.createElement('canvas');
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      return canvas.toDataURL('image/png');
    };

    let imageYPosition = 90;
    for (const url of data.deliveryReceiptDownloadUrls) {
      try {
        const loadedImage = await loadImage(url);
        const dataURL = convertToBase64(loadedImage);
        pdf.addImage(dataURL, 'PNG', 10, imageYPosition, 40, 40);
        imageYPosition += 70;
      } catch (error) {
        console.error('Error loading image:', error);
      }
    }

    pdf.save(`delivery-${data?.id}.pdf`);
  };

  return (
    <div style={cardStyle} onClick={onClick}>
      <div style={buttonContainerStyle}>
        <button style={buttonStyle} onClick={handleDownloadPDF}>Download PDF</button>
        {data.deliveryStage === 'Archive' ? null : <button style={buttonStyle} onClick={handleApproveClick}>Approve</button>}
      </div>
      <div style={infoStyle}>Status: {data.deliveryStatus}</div>
      <div style={infoStyle}>Stage: {data.deliveryStage}</div>
      <div style={infoStyle}>Project: {data.deliveryProject}</div>
      <div style={infoStyle}>Vendor: {data.deliveryVendor}</div>
      <div style={infoStyle}>Notes: {data.deliveryNotes}</div>

      <div style={infoStyle}>
        Receipts:
        <div style={imgRowStyle}>
          {data.deliveryReceiptDownloadUrls?.length === 0 ? (
            <div>No Receipts</div>
          ) : (
            data.deliveryReceiptDownloadUrls?.map((url, index) => (
              <img
                key={index}
                src={url}
                alt={`Receipt ${index}`}
                style={imgStyle}
                onClick={(e) => {
                  e.stopPropagation();
                  handleImageClick(url);
                }}
              />
            ))
          )}
        </div>
      </div>
      <div style={infoStyle}>
        Photos:
        <div style={imgRowStyle}>
          {data.deliveryPhotoDownloadUrls?.length === 0 ? (
            <div>No Deliveries</div>
          ) : (
            data.deliveryPhotoDownloadUrls?.map((url, index) => (
              <img
                key={index}
                src={url}
                alt={`Photo ${index}`}
                style={imgStyle}
                onClick={(e) => {
                  e.stopPropagation();
                  handleImageClick(url);
                }}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default DeliveryCard;

